import cardDragEndHandler from '../Drag/cardDragEndHandler';
import Logger from '../../../../../../../../../utility/services/Logger';

export default (params) => {
  const {
    e,
    nodeProps: { editor, node },
    setDrag,
    getDragType,
    setSnackBar,
    dragOverCords,
  } = params;

  e.stopPropagation();
  try {
    const { type: nodeType } = node;
    const dragType = getDragType(nodeType);
    editor.blur(); // to prevent default insertion

    cardDragEndHandler({
      e,
      editor,
      node,
      setDrag,
      dragType,
      dragOverCords,
    });
  } catch (err) {
    Logger.LogError(err);
    setSnackBar('error');
  }
};
